import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { authFetch } from "../../auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faEllipsisH,
  faTrashAlt,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,
  Container,
  Card,
  Pagination,
  Table,
  Nav,
  Modal,
} from "@themesberg/react-bootstrap";
import { Routes } from "../../routes";
import { FormattedMessage } from "react-intl";

const TableRow = ({ item, idx }) => {
  const {
    id,
    userID,
    userCompany,
    RegistrationID,
    state,
    date,
    response,
    targetNm,
    targetNmInRussian,
    targetID,
  } = item;
  const curState =
    state === 0 ? "Waiting" : state === 1 ? "Accepted" : "Rejected";

  const onConfirm = () => {
    authFetch(process.env.REACT_APP_API_URL + `/api/admin/matching`, {
      method: "POST",
      body: JSON.stringify({
        "matid" : id,
        userCompany,
      }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        window.location.reload();
      });
  };  

  const onCancel = () => {
    authFetch(process.env.REACT_APP_API_URL + `/api/admin/matching/${id}`, {
      method: "DELETE",
      body: JSON.stringify({
        userID,
        RegistrationID,
      }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        window.location.reload();
      });
  };

  return (
    <tr>
      <td>{idx + 1}</td>
      <td style={{ whiteSpace: "normal" }}>
        <span className="fw-normal">{userID}</span>
      </td>
      <td>{userCompany}</td>
      <td>
        <span className="fw-normal">
          <Link
            to={
              Routes.CompInfo.path +
              "?index=company" +
              RegistrationID +
              "&id=" +
              targetID
            }
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {targetNm}
          </Link>{" "}
          {targetNmInRussian && `(${targetNmInRussian})`}
        </span>
      </td>
      <td>
        <span className="fw-normal">{curState}</span>
      </td>
      <td>
        <span className="fw-normal">{date}</span>
      </td>
      <td>{response}</td>
      <td>
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle
            as={Button}
            split
            variant="link"
            className="text-dark m-0 p-0"
          >
            <span className="icon icon-sm">
              <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={onConfirm}
              disabled={state !== 0}
            >
              <FontAwesomeIcon icon={faCheck} className="me-2" /> Confirm
            </Dropdown.Item>
            <Dropdown.Item
              className="text-danger"
              onClick={onCancel}
              disabled={state !== 0}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Cancel
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

const TransactionsTable = ({ transactions }) => {
  const totalTransactions = transactions.length;

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <Card.Body className="pt-0">
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">#</th>
              <th className="border-bottom">UserID</th>
              <th className="border-bottom">User Company</th>
              <th className="border-bottom">Target Company</th>
              <th className="border-bottom">State</th>
              <th className="border-bottom">Date</th>
              <th className="border-bottom">Response</th>
              <th className="border-bottom"></th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((user, idx) => (
              <TableRow key={user.id} item={user} idx={idx} />
            ))}
          </tbody>
        </Table>

        <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
          <small className="fw-bold">
            Showing <b>{totalTransactions}</b> out of <b>{totalTransactions}</b>{" "}
            entries
          </small>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

export default () => {
  const [matList, setMatList] = useState([]);

  useEffect(() => {
    authFetch(process.env.REACT_APP_API_URL + "/api/admin/matching")
      .then((resp) => resp.json())
      .then((resp) => {
        setMatList(resp);
        console.log(resp);
      });
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Admin</Breadcrumb.Item>
            <Breadcrumb.Item active>Managing Matchings</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Matchings</h4>
          <p className="mb-0">Your web analytics dashboard template.</p>
        </div>
      </div>

      <TransactionsTable transactions={matList} />
    </Container>
  );
};
